'use client';

import { CheckCircle2 } from 'lucide-react';

type Props = {
  /** Código de caja del pedido (CASHxxx). */
  cashNumber: string | null;
};

/** Confirmación del tótem público con efectivo: el cliente abona el pedido en caja. */
export function CheckoutCashierStep({ cashNumber }: Props) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-6 px-4 py-20 text-center">
      <CheckCircle2 className="size-24 text-emerald-500" />
      <h3 className="text-3xl font-bold">Pedido generado con éxito</h3>
      {cashNumber && <div className="my-4 text-6xl font-black text-primary">{cashNumber}</div>}
      <p className="max-w-sm text-lg text-muted-foreground">
        Aboná este pedido en la caja para que pase a preparación.
      </p>
    </div>
  );
}
